<template>
  <div v-cloak v-cloak v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <div>
      <!--<i class="el-icon-arrow-left"></i>-->
      <!--<span class="title">My To Do List</span>-->
    </div>

    <div id="breadcrumb">
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ path:'/home' }"><i class="fa fa-home"></i> Home</router-link>
        </li>
        <li>
          <small>Access Control</small>
        </li>
        <li class="active">
          <small>User Mgmt.</small>
        </li>
      </ol>
    </div>
    <confirmation-box ref="deleteDialog" @handleConfirm="handleConfirm"></confirmation-box>
    <add-user ref="addUser" @saveSuccess="saveUserSuccess"></add-user>
    <edit-user ref="editUser" @saveSuccess="saveUserSuccess" :userInfo="userInfo"></edit-user>
    <config-user-role ref="configUserRole" @saveSuccess="saveUserSuccess"></config-user-role>
    <config-user-tag ref="configUserTag" :userId="userId" @saveSuccess="saveUserSuccess"></config-user-tag>

    <div class="tab">
      <el-tabs class="el-tabs" type="border-card">
        <el-tab-pane label="Detail">
          <d1-vue-component ref="basicComponent" :options="generateOption" :dataFacetKey="dataFacetKey" :d1CoreBaseUrl="baseAcsUrl"
                            @onTableOperationButtonClick="handleTableButtonClick"
                            @onToolbarButtonClick="handleToolbarButtonClick"
                            @handleTableDataFormatter="handleTableDataFormatter"

          ></d1-vue-component>
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>

</template>

<script>

  import d1VueComponent from '@/components/d1/acs-d1-vue-component'
  import confirmationBox from '@/components/dialog/confirmation_box.vue'
  import addUser from '@/view/acs/user/dialog/add_user.vue'
  import editUser from '@/view/acs/user/dialog/edit_user.vue'
  import configUserRole from '@/view/acs/user/dialog/config_user_role.vue'
  import configUserTag from '@/view/acs/user/dialog/config_user_tag.vue'
  import util from '@/util/util.js'


  export default {
    props: {

    },
    components: {
      d1VueComponent,
      confirmationBox,
      addUser,
      editUser,
      configUserTag,
      configUserRole
    },
    data(){
      return{
        generateOption: {
          queryUrl: '/acs/user/get-users?sort=gmt_modified,DESC' ,
          importUrl: '',
          exportUrl: '/acs/user/export-users?sort=gmt_modified,DESC',
          deleteUrl: '',
          modifyUrl: '',
          pageSize: 10,
          tableData: [{}],

          pageSettingData: {
            form: [{}],
            table: [{}]
          },
          showTableOperationButton: true,
          tableOperationButtonList: [
            {
              label: 'Edit', //按钮显示的名称
              type: '',  //按钮的类型,默认空,支持  primary，success，info，warning，danger
              name: 'edit', // 按钮点击时间触发的函数名称
              width: 100
            },
            {
              label: 'Config Roles', //按钮显示的名称
              type: '',  //按钮的类型,默认空,支持  primary，success，info，warning，danger
              name: 'config-role', // 按钮点击时间触发的函数名称
              width: 100
            },
            {
              label: 'Config Tag', //按钮显示的名称
              type: '',  //按钮的类型,默认空,支持  primary，success，info，warning，danger
              name: 'config-tag', // 按钮点击时间触发的函数名称
              width: 130
            }
          ],
          toolbarButtonList: [
            {
              label: 'Add ', //按钮显示的名称
              type: 'primary',  //按钮的类型,默认空,支持  primary，success，info，warning，danger
              name: 'add', // 用户点击时返回的组件
              elColWidth: 3, //按钮的占位
            },
            {
              label: 'Delete ', //按钮显示的名称
              type: 'danger',  //按钮的类型,默认空,支持  primary，success，info，warning，danger
              name: 'delete', // 用户点击时返回的组件
              elColWidth: 3, //按钮的占位
            }
          ],
          showToolbarButtonList: true,
          asyncExport:true,
          showSelectColumn: false,
          showTableSelection: true,
          openform:true,
          showForm: true,
          showPagination: true,
          tableDataFormatter: true,
        },
        userInfo:{},
        dataFacetKey: 'ACS_USER_LIST',
        dataLoading: false,
        userId:''
      }
    },
    computed: {

    },
    created(){
    },


    methods: {
      handleToolbarButtonClick(name) {
        if(name === 'add'){
         this.$refs.addUser.showAddUserDialog();
        }else if(name === 'delete'){
          this.$refs.deleteDialog.showDialog();
        }else{
          //nothing to do
        }
      },
      handleTableButtonClick(row, name) {
        // this.handleApprove([row.store_seq], name);
        if(name === 'edit'){
          this.userInfo =  util.deepClone(row);;
          this.$refs.editUser.showEditUserDialog();
        }else if(name === 'config-tag'){
          console.log('papappasososoosos')
          this.userId = row.id;
          this.$refs.configUserTag.showDialog(row.id);
        }else if(name = 'config-role'){
          this.$refs.configUserRole.showConfigRoleDialog(row);
          //nothing to do
        }
      },
      saveUserSuccess(){
        this.$refs.basicComponent.runQuery();
      },
      handleTableDataFormatter(tableDataList) {
        try{
          for (let i = 0; i < tableDataList.length; i++) {
            let tableData = tableDataList[i];
              tableData['enabled'] = tableData['enabled'] === '1' ? 'true' : 'false';
          }
        }catch (e) {
          console.info(e)
        }
        this.$refs.basicComponent.setTableData(tableDataList);
      },
      handleConfirm(){
        if(this.$refs.basicComponent.isSelectionValid){
          let selectRows = this.$refs.basicComponent.getSelection();
          let userIds = [];
          selectRows.forEach( row => {
            userIds.push(row.id);
          });
          let url = this.baseAcsUrl + '/acs/user/delete-users';
          this.dataLoading = true;
          this.http.delete(url,userIds).then(resp =>{
            this.$message.success('Successful operation');
            this.$refs.deleteDialog.hideDialog();
            this.saveUserSuccess();
            this.dataLoading = false;
          }).catch(error => {
            this.dataLoading = false;
            console.info(error);
            this.$message.warning('Operation failure');
          });
        }
      }
    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/view/acs/user/user_list.vue